// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["vendors-node_modules_vue_dist_vue_esm_js","vendors-node_modules_babel_runtime_regenerator_index_js-node_modules_axios_index_js-node_modu-e79845","vendors-node_modules_vue-router_dist_vue-router_esm_js"], function() { return __webpack_require__("./src/aio/js/index.js"); })
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
